<template>
  <ClientsSection ref="clients"></ClientsSection>
</template>

<script>
  import ClientsSection from "./ClientsSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "ClientsWrapper",
    components: {
      ClientsSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
